/* eslint-disable no-unused-vars */
/* eslint-disable */
import Vue from 'vue';
import axios from 'axios';
import Vuex from 'vuex';

Vue.use(Vuex);
export default {
  state: {
    Behaviours: [],
    BehaviourById: []
  },
  getters: {
    getBehaviours(state) {
      return state.Behaviours;
    },
    getBehaviourByid(state) {
      return state.BehaviourById;
    }
  },
  actions: {
    async getBehaviours({ commit }, payload) {
      // .get(`${process.env.VUE_APP_API_URL}api/User/GetUsers`, {

      return await axios
        //.get('https://localhost:44395/api/BehavioralConntroller/GetBehavior', payload)
        .get(`${process.env.VUE_APP_API_URL}/BehavioralConntroller/GetBehavior`, payload)
        //.get(`${process.env.VUE_APP_API_URL}/BehavioralConntroller/GetBehavior`, payload)
        .then((res) => {
          commit('setBehaviours', res.data.data);

          return res.data;
        });
    },
    async AddBehavior({ commit }, payload) {
      return await axios
        .post(`${process.env.VUE_APP_API_URL}/BehavioralConntroller/AddBehavior`, payload, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((res) => {
          return res;
        });
    },
    async UpdateBehavior({ commit }, payload) {
      return await axios
        //.put('https://localhost:44395/api/BehavioralConntroller/UpdateBehaviorById', payload, {
        .put(`${process.env.VUE_APP_API_URL}/BehavioralConntroller/UpdateBehaviorById`, payload, {
          //.post(`${process.env.VUE_APP_API_URL}/BehavioralConntroller/AddBehavior`, payload, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((res) => {
          return res;
        });
    },
    async GetBehaviorbyId({ commit }, Id) {
      return await axios.get(`${process.env.VUE_APP_API_URL}/BehavioralConntroller/GetBehaviorById?Id=${Id}`, Id).then((res) => {
        //return await axios.get(`${process.env.VUE_APP_API_URL}/InstructionalAccommodations/${Id}`, Id).then((res) => {
        commit('GetBehaviourById', res.data.data);
      });
    },
    async DeleteBehaviourById({ commit }, id) {
      return await axios
        //.delete(`https://localhost:44395/api/BehavioralConntroller/DeleteBehaviorById?Id=${id}`).then((res) => {});
        .delete(`${process.env.VUE_APP_API_URL}/BehavioralConntroller/DeleteBehaviorById?Id=${id}`)
        .then((res) => {return res.data});
    }
  },
  mutations: {
    setBehaviours(state, payload) {
      state.Behaviours = payload;
    },
    GetBehaviourById(state, payload) {
      state.BehaviourById = payload;
    }
  }
};
